import { inject, injectable } from "@patsnap/tahiti-core/shared/inversify";
import { WuJieBus } from "./wujie-bus";

/**
 * 消息类型
 */
export interface Message<T = unknown> {
  /**
   * 消息 id
   * @readonly
   */
  readonly id?: string;
  /**
   * 消息类型
   * @readonly
   */
  readonly type?: string;
  /**
   * 回复消息 id
   * @readonly
   */
  readonly replyId?: string;
  /**
   * 消息文本
   * @description 实现该属性，用于标记消息文本, 用于界面展示。
   */
  text: string;
  /**
   * 消息数据
   * @description 实现该属性，用于标记消息数据, 具体用途由具体的消息类型决定。
   */
  data?: T;
}

/**
 * 输入消息类型
 * @description 实现该接口，用于标记输入消息类型。
 */
export type MessageInputType = string;

export interface MessageInput<T = any> extends Message<T>{
  /**
   * 消息类型
   */
  type?: MessageInputType;
  /**
   * 是否需要检查字数限制
   */
  needCheckWordsLimit?: boolean;
}

export const PatsnapCopilotMessageSender = Symbol.for('PatsnapCopilotMessageSender');

export interface PatsnapCopilotMessageSender {
  sendMessage(input: MessageInput): void;
}

@injectable()
export class PatsnapCopilotMessageSenderImpl {
  constructor(
    @inject(WuJieBus)
    private readonly _wujieBus: WuJieBus
  ) {}

  sendMessage(input: MessageInput) {
    this._wujieBus.$emit("send-message", input);
  }
}
